import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";

import Providers from "./Providers";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Get Clerk publishable key from environment variables
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
  console.error(
    "Missing Clerk Publishable Key. Please add VITE_CLERK_PUBLISHABLE_KEY to your .env file"
  );
}

// Helper function to get Remember Me preference
function getRememberMePreference(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("clerk_remember_me") === "true";
}

// Helper function to get session configuration
function getSessionConfig() {
  const rememberMe = getRememberMePreference();
  return {
    // Session expires after:
    // - 1 hour (3600 seconds) if Remember Me is NOT checked
    // - 7 days (604800 seconds) if Remember Me IS checked
    sessionLifetime: rememberMe ? 604800 : 3600,
  };
}

const container = document.getElementById("root")!;
const root = createRoot(container);

// Listen for Remember Me preference changes and re-render
if (typeof window !== "undefined") {
  window.addEventListener("rememberMeChanged", () => {
    console.log("[Clerk] Remember Me preference changed, session config will update on next login");
  });
}

root.render(
  // <StrictMode>
  <ClerkProvider
    publishableKey={CLERK_PUBLISHABLE_KEY}
    afterSignOutUrl="/signin"
    {...(getSessionConfig() as any)}
  >
    <Providers>
      <App />
    </Providers>
  </ClerkProvider>
  // </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
